import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const handleSignout = async () => {
  try {
    // Remove all per-user mydayActiveTab values from sessionStorage
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith('mydayActiveTab_'))
      .forEach((k) => sessionStorage.removeItem(k));
    // First, get the CSRF token
    const csrfResponse = await axios.get(envApiUrl + '/auth/csrf-token', {
      withCredentials: true,
    });
    const csrfToken = csrfResponse.data.csrfToken;

    // Then make the signout request with the CSRF token
    const response = await axios.post(
      envApiUrl + '/auth/signout',
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': csrfToken,
        },
        withCredentials: true,
      },
    );
    console.log('Signout response: ', response);
    return response.data;
  } catch (error) {
    console.error('Signout error: ', error);
    throw error;
  }
};
